import Button from "@mui/material/Button"
import { Grid2 as Grid } from "@mui/material"
import { Formik } from "formik"
import { Fondo } from "../../types"
import { useMemo } from "react"
import * as yup from "yup"
import { transformErrorForForm } from "../../utils/utils"
import { FormInDialogEditProps } from "../DialogForm"
import { useTranslation } from "react-i18next"
import {
  ACPersonaMulti,
  ACLuogoMulti,
  ACEnteMulti,
  ACTagMulti,
} from "./autocompletes"

export default function FondoFormChiavi({ item, save, ref }: FormInDialogEditProps<Fondo>) {
  const { t } = useTranslation()

  const schema = useMemo(
    () =>
      yup.object().shape({

      }),
    [t]
  )

  return (
    <Formik
      validationSchema={schema}
      initialValues={item}
      enableReinitialize
      onSubmit={(values, formikBag) => {
        return save(values as Fondo).catch((e) => {
          const localError = transformErrorForForm(e)
          formikBag.setErrors(localError)
        })
      }}
    >
      {({ handleSubmit, values, setFieldValue }) => {
        return (
          <form onSubmit={handleSubmit} noValidate>
            <Grid container spacing={1} sx={{ py: 2 }}>
              <Grid size={12}>
                < ACPersonaMulti
                  label={t("general.persone")}
                  fullWidth
                  margin="dense"
                  variant="outlined"
                  value={values.persone || []}
                  onChange={(value) => {
                    setFieldValue("persone", value)
                  }}
                />
              </Grid>

              <Grid size={12}>
                < ACLuogoMulti
                  label={t("general.luoghi")}
                  fullWidth
                  margin="dense"
                  variant="outlined"
                  value={values.luoghi || []}
                  onChange={(value) => {
                    setFieldValue("luoghi", value)
                  }}
                />
              </Grid>

              <Grid size={12}>
                < ACEnteMulti
                  label={t("general.enti")}
                  fullWidth
                  margin="dense"
                  variant="outlined"
                  value={values.enti || []}
                  onChange={(value) => {
                    setFieldValue("enti", value)
                  }}
                />
              </Grid>

              <Grid size={12}>
                < ACTagMulti
                  label={t("general.tags")}
                  fullWidth
                  margin="dense"
                  variant="outlined"
                  value={values.tags || []}
                  onChange={(value) => {
                    setFieldValue("tags", value)
                  }}
                />
              </Grid>

            </Grid>

            <Button ref={ref} type="submit" color="primary" sx={{ display: "none" }}></Button>
          </form>
        )
      }}
    </Formik>
  )
}
